/**
 * The date format used in the DC API
 * @type {string}
 */
export const DC_DATE_FORMAT = "yyyy-MM-dd";
